<template>
    <form-row title="Taxes" :label_align_top="true">
        <div class="flex flex-1 flex-col">
            <div class="flex flex-1 flex-col">
                <div v-for="(tax, index) in taxes"
                    :key="tax.id"
                    class="border-b border-gray-400 pb-8 mb-8"
                >
                    <div class="flex">
                        <input-text
                            class="w-full mr-6"
                            :name="'taxes[' + index + '][authority]'"
                            label="Tax authority"
                            v-model="tax.authority"
                            :read_only="read_only"
                        />

                        <input-text
                            class="w-36"
                            :name="'taxes[' + index + '][year]'"
                            label="Year"
                            v-model="tax.year"
                            :read_only="read_only"
                        />
                    </div>

                    <div class="flex mt-6">
                        <input-money
                            class="mr-6"
                            :name="'taxes[' + index + '][amount]'"
                            label="Total tax obligation"
                            v-model="tax.amount"
                            :read_only="read_only"
                        />

                        <input-money
                            class="mr-6"
                            label="Tax/sq.ft."
                            :value="taxes_per_square_foot[index]"
                            :read_only="true"
                        />

                        <input-date
                            :name="'taxes[' + index + '][due_at]'"
                            label="Taxes Due"
                            v-model="tax.due_at"
                            :read_only="read_only"
                        />
                    </div>

                    <div class="flex flex-1 justify-end">
                        <div
                            v-if="! read_only"
                            class="cursor-pointer flex hover:text-red-600 items-center justify-end text-gray-400 w-6"
                            @click="deleteItem(tax)"
                        >
                            <i class="fas fa-minus-circle"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex items-center justify-end">
                <button v-if="! read_only"
                    type="button"
                    class="flex items-center uppercase text-blue-500 hover:text-blue-600 leading-none focus:shadow-none"
                >
                    <span class="text-xl font-bold mr-2">+</span>

                    <span class="inline-block font-semibold text-sm py-2 cursor-pointer select-none"
                        @click="addItem"
                    >
                        {{ $t('Add a tax obligation') }}
                    </span>
                </button>
            </div>
        </div>
    </form-row>
</template>

<script>
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            taxes: this.getTaxes(),
        }
    },

    computed: {
        square_feet() {
            return store.state.square_feet || null;
        },
        taxes_per_square_foot() {
            return this.taxes.map(tax => {
                return this.square_feet && tax.amount
                    ? Math.round(this.formatMoney(tax.amount) / parseInt(this.square_feet) * 100) / 100
                    : null;
            });
        },
    },

    methods: {
        getTaxes() {
            return this.commercial.taxes && this.commercial.taxes.length
                ? this.commercial.taxes
                : [this.getEmptyTaxObject()];
        },
        addItem() {
            this.taxes.push(this.getEmptyTaxObject());
        },
        deleteItem(item) {
            const index = this.taxes.findIndex(tax => tax.id == item.id);

            if (index > -1) {
                this.taxes.splice(index, 1);
            }
        },
        getRandomKey() {
            return Math.floor(Math.random() * (999999 - 1) + 1);
        },
        getEmptyTaxObject() {
            return {
                id: this.getRandomKey(),
                authority: null,
                year: null,
                amount: null,
                due_at: null,
            }
        },
    },
}
</script>
